import { useEffect, useState } from 'react'
import { Box, Card, Grid, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { useAppBase, appPath } from '../components/appBase'
import { eventService } from '../services/eventService'
import type { Speaker } from '../data/types'
import PageContainer from '../components/ui/PageContainer'
import { LoadingState } from '../components/ui/States'
import { resolveAssetUrl } from '../services/assetUrl'

export default function SpeakersPage() {
  const [speakers, setSpeakers] = useState<Speaker[]>([])
  const [loading, setLoading] = useState(true)
  const base = useAppBase()

  useEffect(() => {
    eventService.getSpeakers().then((s) => {
      setSpeakers(s)
      setLoading(false)
    })
  }, [])

  if (loading) return <LoadingState />

  return (
    <PageContainer
      title="Speakers"
      subtitle="Meet the leaders shaping this year's Forum"
    >
      <Grid container spacing={2}>
        {speakers.map((sp) => (
          <Grid item xs={12} sm={6} key={sp.id}>
            <Card
              variant="outlined"
              component={Link}
              to={appPath(base, `speakers/${sp.id}`)}
              sx={{
                p: 2.5,
                display: 'flex',
                gap: 2,
                borderRadius: 3,
                height: '100%',
                textDecoration: 'none',
                color: 'inherit',
                transition: 'border-color .15s, transform .15s',
                '&:hover': { borderColor: 'primary.main', transform: 'translateY(-2px)' },
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: '50%',
                  bgcolor: sp.avatarColor,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: '1.1rem',
                  flexShrink: 0,
                  overflow: 'hidden',
                  backgroundImage: sp.photoUrl
                    ? `url(${resolveAssetUrl(sp.photoUrl)})`
                    : undefined,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                {sp.photoUrl ? '' : sp.initials}
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="subtitle1" fontWeight={700}>
                  {sp.name}
                </Typography>
                <Typography variant="body2" color="primary.main" fontWeight={600}>
                  {sp.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {sp.company}
                </Typography>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </PageContainer>
  )
}
